import styled from "@emotion/styled";
import { getGroupStatusProperty, HHNTheme } from "hhn-commons";

interface PatientHomeIconProps {
  size?: number;
  status: number;
}

const IconWrapper = styled.div`
  display: inline-flex;
`;

const HOUSE_PATH =
  "M29.95,51.59v20.47c0,0.51,0.42,0.93,0.94,0.93h38.7c0.52,0,0.94-0.42,0.94-0.93V51.59l-20.3-20.05L29.95,51.59z M74.64,44.23l-8.6-8.54V26.4c0-1.17-0.96-2.13-2.14-2.13c-1.18,0-2.14,0.95-2.14,2.13v5.03L50.24,20l-24.4,24.23c-1.05,1.04-1.05,2.72,0,3.76c1.05,1.04,2.74,1.04,3.79,0l20.61-20.46l20.61,20.47c0.52,0.52,1.21,0.78,1.89,0.78c0.69,0,1.37-0.26,1.89-0.78C75.68,46.95,75.68,45.27,74.64,44.23z";

const HOSPITAL_PATH =
  "M79.36,64.52c0.08-0.23,0.12-0.47,0.12-0.73V37.02c0-1.27-1.03-2.3-2.29-2.3H64.42v28.49c0,0.46-0.08,0.89-0.23,1.3h-1.5c0.08-0.23,0.12-0.47,0.12-0.73V27.03c0-1.27-1.03-2.3-2.29-2.3H40.48c-1.27,0-2.29,1.03-2.29,2.3v36.77c0,0.25,0.04,0.5,0.12,0.73h-1.5c-0.15-0.41-0.23-0.85-0.23-1.3V34.73H24.12c-1.27,0-2.29,1.03-2.29,2.3v26.77c0,0.25,0.04,0.5,0.12,0.73H18v4.75h65v-4.75H79.36L79.36,64.52z M28.7,55.14h-3.29v-3.29h3.29V55.14z M28.7,49.36h-3.29v-3.29h3.29V49.36z M28.7,43.77h-3.29v-3.29h3.29V43.77z M33.83,55.14h-3.29v-3.29h3.29V55.14z M33.83,49.36h-3.29v-3.29h3.29V49.36z M33.83,43.77h-3.29v-3.29h3.29V43.77z M55.6,64.37h-9.65V52.31h9.65V64.37z M50.5,41.96c-4.47,0-8.09-3.63-8.09-8.1c0-4.47,3.62-8.1,8.09-8.1c4.47,0,8.09,3.63,8.09,8.1S54.97,41.96,50.5,41.96z M71.38,55.14h-3.29v-3.29h3.29V55.14z M71.38,49.36h-3.29v-3.29h3.29V49.36z M71.38,43.77h-3.29v-3.29h3.29V43.77z M76.5,55.14h-3.29v-3.29h3.29V55.14z M76.5,49.36h-3.29v-3.29h3.29V49.36z M76.5,43.77h-3.29v-3.29h3.29V43.77z M52.51,31.85h3.1v4.02h-3.1v3.1h-4.01v-3.1h-3.1v-4.02h3.1v-3.1h4.01V31.85z";

const RIGHT_HALF_PATH =
  "M50,5v90c24.85,0,45-20.15,45-45C95,25.15,74.85,5,50,5z";

const LEFT_HALF_PATH =
  "M50,5v90C25.15,95,5,74.85,5,50C5,25.15,25.15,5,50,5z";

function PatientHomeIcon({ size = 40, status }: PatientHomeIconProps) {
  const { upperBarColor, lowerBarColor } = getGroupStatusProperty(status);
  const isSplit = upperBarColor !== lowerBarColor;

  const iconPath = status === 4 ? HOSPITAL_PATH : HOUSE_PATH;

  return (
    <IconWrapper>
      <svg viewBox="0 0 100 100" width={size} height={size} role="img">
        {isSplit ? (
          <>
            <path d={RIGHT_HALF_PATH} fill={upperBarColor} />
            <path d={LEFT_HALF_PATH} fill={lowerBarColor} />
          </>
        ) : (
          <circle cx="50" cy="50" r="45" fill={upperBarColor} />
        )}
        <path fill={HHNTheme.common.white} d={iconPath} />
        {status === 1 && (
          <>
            <line x1="39" y1="49" x2="61" y2="67" stroke={upperBarColor} strokeWidth="7" strokeLinecap="round" />
            <line x1="61" y1="49" x2="39" y2="67" stroke={upperBarColor} strokeWidth="7" strokeLinecap="round" />
          </>
        )}
      </svg>
    </IconWrapper>
  );
}

export default PatientHomeIcon;
